import { Link } from "react-router-dom";
import { Code2, Globe, Link2, Mail, Share2 } from "lucide-react";
import { Button } from "../Components/ui/Button";
import { Input } from "../Components/ui/Input";

const social = [Code2, Globe, Link2, Share2, Mail];

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white pb-8 pt-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="mb-6 flex items-center gap-3">
              <img src="/Artboardcopy1.png" alt="Quantum Spark Technology" className="h-8 w-8 object-contain opacity-80 grayscale" />
              <span className="font-display text-lg font-bold tracking-tight">Quantum Spark Technology</span>
            </div>
            <p className="mb-6 max-w-sm text-brand-muted">
              Quantum Spark Technology builds software engineered for growth. We deliver high-performance digital products for ambitious companies worldwide.
            </p>
            <div className="flex gap-4">
              {social.map((Icon, i) => (
                <a
                  key={i}
                  href="/contact"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-zinc-100 text-zinc-600 transition-colors hover:bg-brand-purple hover:text-white"
                  aria-label="Social link"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold text-brand-ink">Services</h4>
            <ul className="space-y-3 text-sm text-brand-muted">
              <li>
                <Link to="/services" className="transition-colors hover:text-brand-purple">
                  All services
                </Link>
              </li>
              {["UI/UX Design", "Web Development", "Mobile Apps", "AI Solutions", "Blockchain", "Quality Assurance"].map((item) => (
                <li key={item}>
                  <Link to="/services" className="transition-colors hover:text-brand-purple">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold text-brand-ink">Company</h4>
            <ul className="space-y-3 text-sm text-brand-muted">
              {[
                { label: "About Us", to: "/about" },
                { label: "Our Work", to: "/work" },
                { label: "Blog", to: "/blog" },
                { label: "Careers", to: "/careers" },
                { label: "Contact", to: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition-colors hover:text-brand-purple">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold text-brand-ink">Newsletter</h4>
            <p className="mb-4 text-sm text-brand-muted">Get product and engineering updates from our team.</p>
            <div className="flex gap-2">
              <Input type="email" placeholder="Email address" className="border-zinc-200 bg-zinc-50 text-sm" />
              <Button className="bg-brand-purple text-white hover:bg-brand-purple-dark">Subscribe</Button>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-zinc-100 pt-8 text-sm text-brand-muted md:flex-row">
          <p>© {new Date().getFullYear()} Quantum Spark Technology. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/privacy" className="transition-colors hover:text-brand-ink">
              Privacy Policy
            </Link>
            <Link to="/terms" className="transition-colors hover:text-brand-ink">
              Terms of Service
            </Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("qst-open-consent"))}
              className="transition-colors hover:text-brand-ink"
            >
              Cookie settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
